import React from 'react';
import Hero from '../components/sections/Hero';
import DomainSearch from '../components/sections/DomainSearch';
import FeaturedProject from '../components/sections/FeaturedProject';
import Partners from '../components/sections/Partners';
import About from '../components/sections/About';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import Services from '../components/sections/Services';
import Portfolio from '../components/sections/Portfolio';
import Testimonials from '../components/sections/Testimonials';
import RiyoPos from '../components/sections/RiyoPos';
import Contact from '../components/sections/Contact';
import FloatingActionMenu from '../components/ui/FloatingActionMenu';
import { isSectionEnabled } from '../config/websiteSections';
import { useWebsiteSections } from '../context/WebsiteSectionsContext';

const Home = ({ theme, onToggleTheme }) => {
  const sections = useWebsiteSections();

  return (
    <main>
      {isSectionEnabled(sections, 'hero') ? <Hero theme={theme} onToggleTheme={onToggleTheme} /> : null}
      {isSectionEnabled(sections, 'domainSearch') ? <DomainSearch /> : null}
      {isSectionEnabled(sections, 'featuredProject') ? <FeaturedProject /> : null}
      {isSectionEnabled(sections, 'partners') ? <Partners /> : null}
      {isSectionEnabled(sections, 'about') ? <About /> : null}
      {isSectionEnabled(sections, 'whyChooseUs') ? <WhyChooseUs /> : null}
      {isSectionEnabled(sections, 'services') ? <Services /> : null}
      {isSectionEnabled(sections, 'portfolio') ? <Portfolio /> : null}
      {isSectionEnabled(sections, 'testimonials') ? <Testimonials /> : null}
      {isSectionEnabled(sections, 'riyoPos') ? <RiyoPos /> : null}
      {isSectionEnabled(sections, 'contact') ? <Contact /> : null}
      {isSectionEnabled(sections, 'floatingMenu') ? <FloatingActionMenu /> : null}
    </main>
  );
};

export default Home;
